export enum CustomErrorKey {
  InstancePathParamPosition = 'instancePathParamPosition',
  ErrorParam = 'errorParam',
  AdditionalProperty = 'additionalProperty',
  MissingProperty = 'missingProperty',
  StaticErrorParam = 'staticErrorParam'
}
